// What a file viewer hands the phone's "…" drawer (`PhoneSlot`
// `MEDIA_MORE_SLOT`; drawn by src/phone/media.tsx). Off a phone the viewer
// shows its own menu at the button.
import type { RefObject } from "react";

export const MEDIA_MORE_SLOT = "media.more";

export interface MediaMoreProps {
  open: boolean;
  label: string;
  items: readonly { id: string; label: string; run(): void }[];
  onClose(): void;
  /** The "…" button (the focus goes back there). */
  opener: RefObject<HTMLElement | null>;
}
